<template>
  <label v-if="asLabel && !helpOnly" :for="forId" class="label-with-help">
    <span class="label-with-help-text">
      {{ label }}
      <span v-if="required" class="required-asterisk">*</span>
    </span>
    <span 
      v-if="helpText" 
      class="label-with-help-icon" 
      :data-tooltip="helpText"
    >
      <i class="bi bi-question-circle"></i>
    </span>
  </label>
  <span v-else-if="!asLabel && !helpOnly" class="label-with-help-inline">
    <span class="label-with-help-text">
      {{ label }}
      <span v-if="required" class="required-asterisk">*</span>
    </span>
    <span 
      v-if="helpText" 
      class="label-with-help-icon" 
      :data-tooltip="helpText"
    >
      <i class="bi bi-question-circle"></i>
    </span>
  </span>
  <span 
    v-else-if="helpOnly && helpText" 
    class="label-with-help-icon" 
    :data-tooltip="helpText"
  >
    <i class="bi bi-question-circle"></i>
  </span>
</template>

<script>
import './LabelWithHelp.css';

export default {
  name: 'LabelWithHelp',
  props: {
    label: {
      type: String,
      default: ''
    },
    helpText: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    forId: {
      type: String,
      default: ''
    },
    asLabel: {
      type: Boolean,
      default: true
    },
    helpOnly: {
      type: Boolean,
      default: false
    }
  }
};
</script>
